import { defineMessages } from 'react-intl';

type MessageKeys =
	| 'createAnAgentButton'
	| 'noCreatedAgentsHeader'
	| 'noCreatedAgents'
	| 'noCreatedAgentsHeaderNoPermission'
	| 'noCreatedAgentsNoPermission'
	| 'noStarredAgentsHeader'
	| 'noStarredAgents'
	| 'noVerifiedAgentsHeader'
	| 'noVerifiedAgents'
	| 'seeAllAgentsButton';

const messages: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		createAnAgentButton: {
			id: 'rovo-chat.browse-agents.create-an-agent-button',
			defaultMessage: 'Create an agent',
			description:
				'Button to create a new agent, shown on the empty view when no agents are available',
		},
		noCreatedAgentsHeader: {
			id: 'rovo-chat.browse-agents.no-created-agents-header',
			defaultMessage: 'No agents created yet',
			description: 'Header to display when there are no created agents',
		},
		noCreatedAgents: {
			id: 'rovo-chat.browse-agents.no-created-agents',
			defaultMessage:
				"It looks like you haven't created any agents yet. Start by duplicating other existing agents or begin from scratch to create one.",
			description: 'Message to display when there are no created agents',
		},
		noCreatedAgentsHeaderNoPermission: {
			id: 'rovo-chat.browse-agents.no-created-agents-header-no-permission',
			defaultMessage: "You haven't created any agents",
			description: 'Header to display when there are no created agents and no create permission',
		},
		noCreatedAgentsNoPermission: {
			id: 'rovo-chat.browse-agents.no-created-agents-no-permission',
			defaultMessage: 'You need permission from an admin to create Rovo agents in this site.',
			description: 'Message to display when there are no created agents and no create permission',
		},
		noStarredAgentsHeader: {
			id: 'rovo-chat.browse-agents.no-starred-agents-header',
			defaultMessage: "You haven't starred an agent yet",
			description: 'Header to display when there are no starred agents',
		},
		noStarredAgents: {
			id: 'rovo-chat.browse-agents.no-starred-agents',
			defaultMessage:
				"If you've got a favourite agent or one that you use often, star it for easy access.",
			description: 'Message to display when there are no starred agents',
		},
		noVerifiedAgentsHeader: {
			id: 'rovo-chat.browse-agents.no-verified-agents-header',
			defaultMessage: 'No verified agents',
			description: 'Header to display when there are no verified agents',
		},
		noVerifiedAgents: {
			id: 'rovo-chat.browse-agents.no-verified-agents',
			defaultMessage:
				'Agents need to be reviewed and approved by your organization’s admins before they appear here.',
			description: 'Message to display when there are no verified agents',
		},
		seeAllAgentsButton: {
			id: 'rovo-chat.browse-agents.see-all-agents-button',
			defaultMessage: 'See all agents',
			description: 'Button to see all agents, shown on the empty view when no agents are starred',
		},
	});

export default messages;
